import { render, staticRenderFns } from "./tradesman.vue?vue&type=template&id=ed170122&scoped=true&"
import script from "./tradesman.vue?vue&type=script&lang=js&"
export * from "./tradesman.vue?vue&type=script&lang=js&"
import style0 from "./tradesman.vue?vue&type=style&index=0&id=ed170122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed170122",
  null
  
)

export default component.exports